/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse, Logger } from '@app/core';
import { Model } from '@app/shared/models/model.model';
import { HttpClient } from '@angular/common/http';
import { Company } from '@app/settings/companies/company.model';

const log = new Logger('CompaniesService');

@Injectable({
  providedIn: 'root',
})
export class CompaniesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery(), forceUpdate: boolean = false): Observable<PaginatedResponse> {
    log.debug('index');
    return this.http
      .cache(forceUpdate)
      .get('v1/companies', query.buildGetOptions())
      .pipe(
        map((response: HttpResponse) => {
          response.data = response.data.map((company: any) => {
            return new Company().deserialize(company);
          });
          return new PaginatedResponse().deserialize(response);
        })
      );
  }

  update(company: Company): Observable<Company> {
    return this.http.put('v1/companies/' + company.id, company).pipe(
      map((response: HttpResponse) => {
        return new Company().deserialize(response.data);
      })
    );
  }

  store(company: Company): Observable<Company> {
    return this.http.post('v1/companies', company).pipe(
      map((response: HttpResponse) => {
        return new Company().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/companies/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Company().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/companies/' + id);
  }
}
